import { gql } from '@generated/gql';

const getBundleBenefits = gql(`
  query BundleBenefits($basketID: ID!) {
    bundleBenefits(basketID: $basketID) {
      coreServiceCount
      benefits {
        emphasisedText
        unemphasisedText
      }
    }
  }
`);

export { getBundleBenefits };
